import { Avatar } from '@lunary/ui-web/avatar'
import { Link } from '@tanstack/react-router'
import { useAdminAuth } from '../../shared/auth/admin-auth-context'
import { userTitle } from './identity'
import { roleLabel, sourceLabel } from './labels'
import { useAdminUser, useUserActivity } from './queries'
import { UserActions } from './user-actions'
import { UserHistory } from './user-history'
import { UserProfile } from './user-profile'
import { UserSources } from './user-sources'
import styles from './user-card.module.css'

export function UserCardPage({ userId }: { userId: string }) {
  const { user: me, status } = useAdminAuth()
  const isAdmin = status === 'authenticated' && (me?.role === 'admin' || me?.role === 'expert')
  const user = useAdminUser(userId)
  const activity = useUserActivity(userId)

  if (!isAdmin) return <p className="error-box">Раздел доступен только сотрудникам.</p>

  return (
    <div>
      <Link to="/users" className={styles.back}>
        ← Все пользователи
      </Link>
      {user.isPending && <div className="spinner" aria-label="Загрузка" />}
      {user.isError && <p className="error-box">Пользователь не найден или недоступен.</p>}
      {user.data && (
        <>
          <header className={styles.header}>
            <Avatar src={user.data.avatar_url} name={userTitle(user.data).title.replace('@', '')} size={56} />
            <div>
              <h1 className={styles.name}>{userTitle(user.data).title}</h1>
              <div className={styles.badges}>
                <span className="badge">{roleLabel(user.data.role)}</span>
                <span className="badge">{sourceLabel(user.data.signup_source)}</span>
                {user.data.blocked_at ? (
                  <span className="badge danger">Заблокирован</span>
                ) : (
                  <span className="badge ok">Активен</span>
                )}
              </div>
            </div>
          </header>
          <div className={styles.grid}>
            <div className={styles.side}>
              <UserProfile user={user.data} activeSessions={activity.data?.active_sessions ?? null} />
              <UserSources userId={user.data.id} />
              <UserActions user={user.data} isSelf={user.data.id === me.id} canSetRole={me.role === 'admin'} lockedByAdmin={me.role !== 'admin' && user.data.role === 'admin'} />
            </div>
            <UserHistory activity={activity.data} />
          </div>
          {activity.isError && <p className="error-box">Не удалось загрузить историю.</p>}
        </>
      )}
    </div>
  )
}
